import { render, staticRenderFns } from "./ChangePasswordPage.vue?vue&type=template&id=23470019&scoped=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./ChangePasswordPage.vue?vue&type=style&index=0&id=23470019&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23470019",
  null
  
)

export default component.exports